import React, { Component } from 'react';
import analytics from 'rewind-analytics';

import { withContext } from '../../App';

class AnswerButton extends Component {
  componentWillUnmount() {
    this.props.context.resetSelectedOption();
  }

  trackClick(type) {
    const { topic } = this.props;
    const { completeScenario } = this.props.context;

    completeScenario(topic);

    analytics.count({
      groupName: `answer-button`,
      eventName: `Answered - ${type} in ${topic}`,
      unique: true
    });
  }

  render() {
    const { type } = this.props;
    const { toggleModal } = this.props.context;

    return (
      <button className={`answer-button ${type}`} onClick={() => { this.trackClick(type); toggleModal(type) }}>
        {type}
      </button>
    );
  }
}

export default withContext(AnswerButton);

AnswerButton.defaultProps = {
  type: 'yes'
}